import { makeStyles } from '@material-ui/styles';

export default ({ loading }: any) =>
  makeStyles(() => ({
    root: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end'
    },

    spinner: {
      color: 'white',
      position: 'absolute',
    },

    title: {
      position: 'relative',
      color: loading ? 'transparent' : '',
    },

    margin: {
      position: 'relative',
      paddingLeft: '40px',
      paddingRight: '40px',
      backgroundColor: '#db0001',
      boxShadow: '0px 10px 20px -5px rgba(145, 145, 145, 0.4)',
      transition: 'all 0.3s ease',

      '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#a30001',
        boxShadow: '0px 12px 24px -5px rgba(145, 145, 145, 0.5)',
      }
    }
  }));
